import { NgModule } from '@angular/core';

import { DirectivesModule } from '../../../../directives';
import { PipesModule } from '../../../../pipes';
import { SharedModule } from '../../../../shared/shared.module';
import { ManagerComponentsModule } from '../../components/manager-components.module';
import {
	UsersAccountMigrationDialogComponent,
	UsersDeleteEmailDialogComponent,
	UsersEditEmailDialogComponent,
	UsersEditUserAttributesDialogComponent,
	UsersManageRolesDialogComponent,
	UsersRolesSourcesDialogComponent,
	UsersManualPasswordResetDialogComponent,
	UsersSearchFormModule,
	UsersSendResetPasswordEmailDialogComponent,
	UsersSendVerificationEmailDialogComponent,
	UsersSuspendToggleDialogComponent,
	UsersTermsAcceptanceDialogComponent,
	UsersTermsAcceptDialogComponent,
	UsersVerifyEmailDialogComponent
} from './components';
import { UsersComponent } from './users.component';
import { UsersRoutingModule } from './users.routing';

const modules = [SharedModule, UsersRoutingModule, UsersSearchFormModule, ManagerComponentsModule, DirectivesModule, PipesModule];

const components = [
	UsersComponent,
	UsersAccountMigrationDialogComponent,
	UsersVerifyEmailDialogComponent,
	UsersManageRolesDialogComponent,
	UsersRolesSourcesDialogComponent,
	UsersManualPasswordResetDialogComponent,
	UsersSendResetPasswordEmailDialogComponent,
	UsersSendVerificationEmailDialogComponent,
	UsersTermsAcceptDialogComponent,
	UsersTermsAcceptanceDialogComponent,
	UsersEditUserAttributesDialogComponent,
	UsersSuspendToggleDialogComponent,
	UsersDeleteEmailDialogComponent,
	UsersEditEmailDialogComponent
];

@NgModule({
	imports: [...modules],
	exports: [...components],
	declarations: [...components],
	providers: []
})
export class UsersModule {}
